
export class StageModel
{
  constructor(id, sound, base = null, next = true)
  {
    this.id = id
    this.sound = sound
    this.base = base
    this.next = next
  }
}
